export default __webpack_public_path__ + "static/media/django.497d37be.svg";